import { Button, Grid } from '@mui/material';
import React, { FC } from 'react';
import { FormCheckBox } from 'src/components/FormPart/FormCheckBox';
import { FormDropdown } from 'src/components/FormPart/FormDropdown';
import { FormTextInput } from 'src/components/FormPart/FormTextInput';
import { FormComponentProps } from 'src/components/FormPart/types';
import { SelectOption } from 'src/UIKit';
import { Application } from 'src/modules/applications/types';
import { CreateAdminCompanyFormData } from '../../types';

type CreateAdminCompanyFormProps = {
  applicationOptions: SelectOption<string, string, Application>[];
  disabled?: boolean;
  onSubmit?: (formData?: CreateAdminCompanyFormData) => void;
};

export const CreateAdminCompanyForm: FC<
  FormComponentProps<CreateAdminCompanyFormData, CreateAdminCompanyFormProps>
> = props => {
  const { form, applicationOptions, onSubmit, disabled } = props;

  const handleSubmit = () => {
    if (!onSubmit) return;
    onSubmit(form.getValues());
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <FormTextInput
          form={form}
          fieldName="name"
          disabled={disabled}
          label="Name"
          placeholder="Enter Name"
          validation={{
            required: 'Company Name is required',
          }}
        />
      </Grid>

      <Grid item xs={6}>
        <FormDropdown
          form={form}
          fieldName="applicationId"
          label="Application"
          disabled={disabled}
          placeholder="Enter Application"
          options={applicationOptions}
          validation={{
            required: 'Application is required',
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <FormCheckBox
          form={form}
          disabled={disabled}
          fieldName="createMessageProfile"
          label="Create a Messaging Profile for this company?"
        />
      </Grid>

      <Grid item xs={12} display="flex" justifyContent="flex-end">
        <Button
          type="button"
          onClick={handleSubmit}
          disabled={!form.formState.isValid}
          variant="contained"
          color="secondary"
          size="large"
        >
          Next
        </Button>
      </Grid>
    </Grid>
  );
};
